import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import {
  Button,
  TextField,
  Box,
  Typography,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  CircularProgress,
  Paper,
  Divider,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useAuth } from "../../Context/AuthContext";

import axios from "axios";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const style = {
  width: "80vw",
  overflow: "auto",
  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "#d9d9d9 #fff", // For Firefox
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d9d9d9",
  },
  maxHeight: "85vh",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  // borderRadius: "12px",
};

function UpdateLeadsAndClients({
  isEditDialogOpen,
  handleCloseEditDialog,
  clientList,
  selectedId,
  roleId,
  onStatusUpdate,
}) {
  const { token } = useAuth();
  const personsListStatus = clientList[clientList.length - 1]?.status;

  const [currentUser, setCurrentUser] = useState("");
  const [rmOptions, setRmOptions] = useState([]);
  const [managerIdNameMap, setManagerIdNameMap] = useState({});

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onTouched" });

  console.log("clientList:", clientList[0]?.created_date);
  const initialKycStatus = [
    {
      feildName: "Name As Per Pan",
      status: "Pending",
      keyWord: "nameAsPerPanStatus",
    },
    { feildName: "Pan Number", status: "Pending", keyWord: "panNumberStatus" },
    {
      feildName: "DOB Of Investor",
      status: "Pending",
      keyWord: "dobOfInvestorStatus",
    },
    {
      feildName: "Place Of Birth",
      status: "Pending",
      keyWord: "placeOfBirthStatus",
    },
    {
      feildName: "Postal Address 1",
      status: "Pending",
      keyWord: "postalAddress1Status",
    },
    {
      feildName: "Postal Address 2",
      status: "Pending",
      keyWord: "postalAddress2Status",
    },
    { feildName: "City", status: "Pending", keyWord: "kycCityStatus" },
    { feildName: "State", status: "Pending", keyWord: "kycStateStatus" },
    { feildName: "Pin Code", status: "Pending", keyWord: "pincodeStatus" },
    {
      feildName: "Nominee Name",
      status: "Pending",
      keyWord: "nomineeNameStatus",
    },
    {
      feildName: "Nominee DOB",
      status: "Pending",
      keyWord: "nomineeDobStatus",
    },
    {
      feildName: "Nominee Relation With Investor",
      status: "Pending",
      keyWord: "nomineeRelationWithInvestorStatus",
    },
    { feildName: "Occupation", status: "Pending", keyWord: "occupationStatus" },
    {
      feildName: "Investor's Income Range",
      status: "Pending",
      keyWord: "investorsIncomeRangeStatus",
    },
    {
      feildName: "Source Of Income",
      status: "Pending",
      keyWord: "sourceOfIncomeStatus",
    },
    { feildName: "Pan Image", status: "Pending", keyWord: "panImgStatus" },
    {
      feildName: "Cancelled Cheque Image",
      status: "Pending",
      keyWord: "cancelledCheckImgStatus",
    },
    {
      feildName: "CKYC Number ",
      status: "Pending",
      keyWord: "ckycNumberStatus",
    },
  ];
  const [kycStatusObj, setKycStatusObj] = useState({
    status: false,
    data: initialKycStatus,
  });
  React.useEffect(() => {
    if (isEditDialogOpen && selectedId) {
      const existingData = clientList.find(
        (client) => client.id === selectedId
      );
      console.log(existingData, "existingData");
      if (existingData) {
        initialKycStatus.map((dta, idx) => {
          dta.status = existingData?.[dta.keyWord];
        });
        // console.log(initialKycStatus, "idx");
        setKycStatusObj({ status: true, data: initialKycStatus });
        setValue("kycStatus", existingData.kycStatus);
        setValue("id", existingData.id);
        setValue("comments", existingData.comments);
        setValue(
          "referralName",
          `${existingData.firstname} ${existingData.lastname}`
        );
        setCurrentUser(`${existingData.firstname} ${existingData.lastname}`);
        setValue("email", existingData.email);
        setValue("phone", existingData.phone);
        const formattedDate = existingData.firstContactDate
          ? existingData.firstContactDate.slice(0, 10)
          : "";
        setValue("firstContactDate", formattedDate);
        // setValue("referredByName", existingData.referredByName);
        setValue("leadReferredBy", existingData.leadReferredBy);
        // setValue("managerName", existingData.managerName);
        setValue("managerId", existingData.managerId);

        const formValues = getValues();
        setValue("managerName", managerIdNameMap[formValues.managerId]);
        setValue("location", existingData.location);
        setValue("automobileOwned", existingData.automobileOwned);
        setValue("description", existingData.description);
        setValue("clubMembership", existingData.clubMembership);
      }
    }
  }, [isEditDialogOpen, selectedId, setValue, getValues, clientList]);

  //--------------------------------------------------------------------
  const getKycStatusBox = (kycStatus) => {
    const styles = {
      Completed: {
        border: "2px solid green",
        color: "green",
      },
      Pending: {
        border: "2px solid red",
        color: "red",
      },
      default: {
        border: "2px solid gray",
        color: "black",
      },
    };

    const currentStyle = styles[kycStatus] || styles.default;

    return (
      <Box
        component="span"
        sx={{
          ...currentStyle,
          width: "150px",
          borderRadius: "30px",
          px: 1,
          py: 0.5,
          fontWeight: "bold",
          fontSize: "15px",
          marginLeft: 1,
        }}
      >
        {kycStatus}
      </Box>
    );
  };

  const handleReferralNameChange = (event) => {
    const fullName = event.target.value;
    const [firstname, lastname] = fullName.split(" ");
    setValue("firstname", firstname);
    setValue("lastname", lastname);
  };

  //------------------------------for Manager list-----------------------------

  useEffect(() => {
    const handleRole = async () => {
      try {
        console.log("roles", roleId);
        const apiResult = await axios.post(
          `${apiUrl}/CCE/api/v1/userEngine/users`,
          {
            roleId: "1,2,6",
          }
        );
        const options = apiResult?.data?.response || [];
        setRmOptions(options);

        const idNameMap = options.reduce((map, option) => {
          map[option.id] = option.firstname + " " + option.lastname;
          return map;
        }, {});
        setManagerIdNameMap(idNameMap);
      } catch (error) {
        console.error("Error fetching rm data:", error.message);
      }
    };

    handleRole();
  }, [roleId]);

  console.log("rmOptionsNew", rmOptions);

  // -------------------------------edit Api handling----------------------------------|\

  const onSubmit = async (data) => {
    console.log("update button call");
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.put(
        `${apiUrl}/CCE/api/v1/referalEngine/updateReferral`,
        {
          ...data,
          referredId: selectedId,
        },
        { headers }
      );
      if (response?.data?.statusMessage === "Success") {
        toast.success("Response updated successfully");
        onStatusUpdate("success");
      } else {
        toast.error("Update failed");
        onStatusUpdate("failure");
      }
      console.log("Check Three");
      console.log("clientRes", response);
    } catch (error) {
      toast.error("Update failed");
      onStatusUpdate("failure");
    }

    reset();
    handleCloseEditDialog();
    onStatusUpdate("success");
  };

  //-----------------cancel------------------|\

  const cancelHandler = () => {
    handleCloseEditDialog();
    reset();
  };

  // --------------------------------------------------------------------------------------------------|\

  return (
    <div>
      <ToastContainer
        position="bottom-right"
        autoClose={7000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        toastStyle={{ textAlign: "left" }}
        theme="colored"
      />
      <Modal
        open={isEditDialogOpen}
        onClose={handleCloseEditDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ marginBottom: "1rem", textAlign: "center" }}
          >
            {personsListStatus === "lead" ? (
              <>Update Lead </>
            ) : (
              <>Update Client</>
            )}
            <Typography variant="span" sx={{ ml: 0.5, fontWeight: "bold" }}>
              {currentUser}
            </Typography>
          </Typography>

          <Typography variant="h6" sx={{ ml: 1, mb: 1 }}>
            KYC Status
            <Box
              component="span"
              sx={{
                border:
                  watch("kycStatus") === "Completed"
                    ? "2px solid green"
                    : watch("kycStatus") === "Pending"
                    ? "2px solid red"
                    : watch("kycStatus") === "Incomplete"
                    ? "2px solid orange"
                    : "2px solid gray",
                width: "150px",
                borderRadius: "30px",
                color:
                  watch("kycStatus") === "Completed"
                    ? "green"
                    : watch("kycStatus") === "Pending"
                    ? "red"
                    : watch("kycStatus") === "Incomplete"
                    ? "orange"
                    : "black",
                px: 1,
                py: 0.5,
                fontWeight: "bold",
                fontSize: "15px",
                marginLeft: 1,
              }}
            >
              {watch("kycStatus")}
            </Box>
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} my={1}>
              <Grid item xs={12} sm={4}>
                {personsListStatus === "lead" ? (
                  <>
                    <TextField
                      size="medium"
                      sx={styles.textfield}
                      id="outlined-basic"
                      label="Lead Name"
                      variant="outlined"
                      {...register("referralName", {
                        required: "Referral Name is required",
                        errorMessage:
                          "Referral Name is allowed in only letters",
                        pattern: {
                          value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                          message: "Only alphabets are allowed",
                        },
                      })}
                      onChange={handleReferralNameChange}
                    />
                    {errors.referralName && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          textAlign: "left",
                          marginLeft: "10px",
                        }}
                      >
                        {errors.referralName.message}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <TextField
                      size="medium"
                      sx={styles.textfield}
                      id="outlined-basic"
                      label="Client Name"
                      variant="outlined"
                      {...register("referralName", {
                        required: "Referral Name is required",
                        errorMessage:
                          "Referral Name is allowed in only letters",
                        pattern: {
                          value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                          message: "Only alphabets are allowed",
                        },
                      })}
                      onChange={handleReferralNameChange}
                    />
                    {errors.referralName && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "14px",
                          textAlign: "left",
                          marginLeft: "10px",
                        }}
                      >
                        {errors.referralName.message}
                      </div>
                    )}
                  </>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Email address"
                  variant="outlined"
                  {...register("email", {
                    // required: "Email address is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid Email Address",
                    },
                  })}
                />
                {errors.email && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.email.message}
                  </div>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Phone number"
                  variant="outlined"
                  inputProps={{ maxLength: 10 }}
                  {...register("phone", {
                    required: "Phone number is required",
                    pattern: {
                      value: /^\d{10}$/,
                      message: "Invalid Phone Number (10 digits)",
                    },
                    validate: (value) => !!value || !!watch("email"),
                    onChange: (e) =>
                      (e.target.value = e.target.value.replace(/\D/g, "")),
                  })}
                />
                {errors.phone && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.phone.message}
                  </div>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Comments (optional)"
                  variant="outlined"
                  {...register("comments", {})}
                />
                {errors.comments && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.comments.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-date"
                  label="First Contact Date"
                  type="date"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("firstContactDate", {
                    required: "date is required",
                  })}
                  InputProps={{
                    inputProps: {
                      placeholder: "Select Date",
                      max: new Date().toISOString().split("T")[0],
                      defaultValue: new Date().toISOString().split("T")[0],
                    },
                  }}
                />
                {errors.created_date && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.created_date.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-leadReferredBy"
                  label="Referred by"
                  type="leadReferredBy"
                  variant="outlined"
                  {...register("leadReferredBy", {
                    required: "Referred by is required",
                    errorMessage: "Referred by is allowed in only letters",
                    pattern: {
                      value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                />
                {errors.leadReferredBy && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.leadReferredBy.message}
                  </div>
                )}
              </Grid>

              {roleId === "2" && (
                <Grid item xs={12} sm={4}>
                  <TextField
                    size="medium"
                    sx={styles.textfield}
                    id="outlined-managerName"
                    label="Wealth Advisor"
                    type="managerName"
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                    {...register("managerName")}
                  />
                  {errors.manager && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.managerName.message}
                    </div>
                  )}
                </Grid>
              )}

              {roleId === "1" && (
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth variant="outlined" size="medium">
                    <InputLabel id="rm-select-label">Wealth Advisor</InputLabel>
                    <Controller
                      name="managerId"
                      control={control}
                      defaultValue={null}
                      rules={{
                        required: "Manager Name is required ",
                      }}
                      render={({ field }) => (
                        <Select
                          label="Wealth Advisor"
                          labelId="rm-select-label"
                          {...field}
                          sx={styles.textfield}
                        >
                          {rmOptions.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.firstname} {option.lastname}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                  {errors.manager && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.manager.message}
                    </div>
                  )}
                </Grid>
              )}

              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-location"
                  label="Location"
                  type="location"
                  variant="outlined"
                  {...register("location", {
                    // required: "Location is required",
                  })}
                />
                {errors.location && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.location.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-automobileOwned"
                  label="Automobile Owned"
                  type="automobileOwned"
                  variant="outlined"
                  {...register("automobileOwned", {
                    // required: "Referred by is required",
                  })}
                />
                {errors.automobileOwned && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.automobileOwned.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-clubMembership"
                  label="Club Membership"
                  type="clubMembership"
                  variant="outlined"
                  {...register("clubMembership", {
                    // required: "Club membership by is required",
                  })}
                />
                {errors.clubMembership && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.clubMembership.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="medium"
                  sx={styles.textfield}
                  id="outlined-description"
                  label="Good About Referral"
                  type="description"
                  variant="outlined"
                  {...register("description", {
                    // required: "Club membership by is required",
                  })}
                />
                {errors.description && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.description.message}
                  </div>
                )}
              </Grid>
            </Grid>
            <Paper
              elevation={10}
              sx={{
                backgroundColor: "#213B68",
                color: "#ffffff",
                py: 1.5,
                px: 2,
                borderRadius: "5px",
              }}
            >
              KYC Details
            </Paper>
            <Box sx={{ width: "100%", position: "relative" }}>
              <Grid container spacing={2} my={1}>
                {kycStatusObj?.status ? (
                  <>
                    {kycStatusObj.data.map((dta, idx) => (
                      <Grid key={idx} item xs={12} sm={4}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            py: 1,
                            marginRight: 2,
                            marginLeft: 2,
                          }}
                        >
                          <Box component="span">{dta.feildName}</Box>
                          <Box component="span">
                            {getKycStatusBox(dta.status)}
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </>
                ) : (
                  <CircularProgress />
                )}
              </Grid>

              {/* Standalone dividers */}
              <Divider
                orientation="vertical"
                sx={{
                  position: "absolute",
                  left: "33.33%",
                  top: 0,
                  bottom: 0,
                  height: "100%",
                }}
              />
              <Divider
                orientation="vertical"
                sx={{
                  position: "absolute",
                  left: "66.66%",
                  top: 0,
                  bottom: 0,
                  height: "100%",
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex ",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Button
                onClick={cancelHandler}
                variant="outlined"
                sx={{
                  color: "Black",
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  padding: "5px 15px",
                  background: "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  textTransform: "none",
                  "&:hover": { background: "#002C51" },
                }}
              >
                Update
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default UpdateLeadsAndClients;

const styles = {
  textfield: {
    width: "335px",
  },
};
